import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import "moment/locale/ar";
import "moment/locale/en-gb";

type Props = {
  date?: string;
};

const DateTimeText: React.FC<Props> = ({ date }) => {
  const { i18n } = useTranslation();
  const [formattedDate, setFormattedDate] = useState("");
  const [relativeTime, setRelativeTime] = useState("");

  useEffect(() => {
    if (!date) {
      setFormattedDate("----");
      setRelativeTime("");
      return;
    }

    const userTimeZone =
      Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Jerusalem";

    // Function to update formatted and relative time
    const updateTime = () => {
      // Set Moment locale
      moment.locale(i18n.language === "ar" ? "ar" : "en-gb");

      const m = moment(date).tz(userTimeZone);
      setFormattedDate(m.format("LL HH:mm")); // Absolute date
      setRelativeTime(m.fromNow()); // Relative time
    };

    updateTime();

    // Update every minute for live relative time
    const interval = setInterval(updateTime, 60000);

    return () => clearInterval(interval);
  }, [date, i18n.language]);

  if (!date) return <>----</>;

  return (
    <span title={formattedDate}>
      {formattedDate} ({relativeTime})
    </span>
  );
};

export default DateTimeText;
